// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_RECENT_POSTS = "Nejnov\u011bj\u0161\u00ed ot\u00e1zky z poradny";
export const FORUM_RELATED_DISCUSSIONS = "Souvisej\u00edc\u00ed diskuze";
export const FORUM_SIMILAR_DISCUSSIONS = "Podobn\u00e9 diskuze";
export const RELATED_BLOG_ARTICLES = "Podobn\u00e9 \u010dl\u00e1nky";
export const RELATED_DISCUSSIONS_IN_FORUM = "Souvisej\u00edc\u00ed diskuze ve f\u00f3ru";
export const RELATED_REVIEW_ARTICLES = "Souvisej\u00edc\u00ed recenze produkt\u016f";
export const YOUTUBE_MK_TITLE = "YouTube Modr\u00fd kon\u00edk";
